import { View } from '@lernetz/ts-lib';

import debounce from '../utility/debounce';

import topicTemplate from './Topic.html';


type Asset = any;


export interface Topic {
    color: string;
    coverPreview: Asset;
    duration: string;
    goals: string[];
    title: string;
}


export class TopicView extends View<Topic> {

    private static nextId: number = 1;

    private id: number;
    private style: HTMLStyleElement;

    constructor() {
        super({ template: topicTemplate });
    }

    init() {
        this.id = TopicView.nextId++;
        this.node.querySelector('.topic-element').setAttribute('data-id', `${this.id}`);

        window.addEventListener('resize', debounce(this.onWindowResize.bind(this), 250, false));
        setTimeout(this.onWindowResize.bind(this), 250);
    }

    onWindowResize() {
        // Make the cover image the same height as the main content:
        const cover = <HTMLElement> this.node.querySelector('.cover');
        const bodyHeight = this.node.querySelector('.body').getBoundingClientRect().height;
        cover.style.height = `${bodyHeight}px`;

        // Update the style for just this component for the shift-on-hover effect:
        if (this.style) {
            document.head.removeChild(this.style);
        }

        // (This is rather ugly, but unfortunately unavoidable.
        // At least that's my verdict after experimenting for way more than 10 hours.)
        const css = `@media all and (min-width: 48rem) {
            .topic-element[data-id='${this.id}'] > .interior {
                transform: translateY(${bodyHeight + 1}px);
            }
            .topic-element[data-id='${this.id}'] > .interior:hover {
                transform: none;
            }
        }`;
        // ^ the +1px hopefully fixes a hairline pixel rounding error that's
        //   sometimes visible in some browsers

        // TODO:
        this.style = document.createElement('style');
        this.style.appendChild(document.createTextNode(css));
        document.head.appendChild(this.style);
    }
}
